// 统一请求路径前缀在libs/axios.js中修改
// import { getRequest, postRequest, putRequest, deleteRequest, importRequest, uploadFileRequest, downloadFileRequest } from '@/libs/axios'
import { getRequest,getRequestSteamCard, postRequest, putRequest, deleteRequest,uploadRequest } from '@/libs/axios'

// Vaptcha ID
export const vaptchaID = '5bb9a277fc650e00a4155567'
// 发送重置密码短信验证码
export const sendResetSms = (params) => {
  return postRequest('/common/captcha/sendResetSms', params)
}
// 通过手机重置密码
export const resetByMobile = (params) => {
  return postRequest('/user/resetByMobile', params)
}
// 发送重置密码邮件验证码
export const sendResetEmail = (params) => {
  return postRequest('/email/sendResetCode', params)
}
// 通过邮件重置密码
export const resetByEmail = (params) => {
  return postRequest('/email/resetByEmail', params)
}
// 分页获取消息推送数据
export const getMessageSendData = params => {
  return getRequest('/messageSend/getByCondition', params)
}
// 编辑发送消息
export const editMessageSend = params => {
  return putRequest('/messageSend/update', params)
}
// 删除发送消息
export const deleteMessageSend = (ids, params) => {
  return deleteRequest(`/messageSend/delByIds/${ids}`, params)
}
// 个人中心修改密码
export const changePass = params => {
  return getRequest('/v3/student/updatePassword', params)
}
export const getAdListByType = params => {
  return getRequest('/v3/student/getAdListByType', params, true)
}
// 获取广告信息列表
export const getAdList = params => {
  return getRequest(`/v3/student/ad/admin/getAdList`, params)
}
// 登录页精选作品
export const getFeaturedOpusList = params => {
  return getRequest('/v3/student/getFeaturedOpusList', params, true)
}
// 获取登录页精选作品详情
export const getFeaturedOpusDetails = params => {
  return getRequest('/v3/student/getOpusDetails', params, true)
}
// 获取编程小新星列表
export const getProgramNewStarList = params => {
  return getRequest('/v3/student/getNewsArticleList', params, true)
}
// 编程小新星详情查看
export const getProgramNewStarDetails = params => {
  return getRequest('/v3/student/getNewsArticleDetails', params, true)
}
// 编程小新星评论列表
export const getProgramNewStarCommentsList = params => {
  return getRequest('/v3/student/getNewsArticleCommentsList', params, true)
}
// 登陆
export const login = params => {
  return postRequest('/v3/student/login', params, true)
}
// 获取用户登录信息
export const userInfo = params => {
  return getRequest('/v3/student/getStudentInfo', params)
}
// 获取用户登录信息SteamCard
export const userInfoSteamCard = params => {
  return getRequestSteamCard('/v3/student/getStudentInfo', params)
}
// 个人中心编辑
export const userInfoEdit = params => {
  return postRequest('/user/edit', params)
}
// 获取绑定账号信息
export const relatedInfo = (username, params) => {
  return getRequest(`/relate/getRelatedInfo/${username}`, params)
}
// 解绑账号
export const unRelate = params => {
  return postRequest('/relate/delByIds', params)
}

// 个人中心发送修改邮箱验证邮件
export const editEmail = params => {
  return postRequest('/email/editEmail', params)
}
// 发送短信验证码
export const sendSms = (mobile, params) => {
  return getRequest(`/common/captcha/sendSms/${mobile}`, params)
}
// 个人中心修改手机
export const changeMobile = params => {
  return postRequest('/user/changeMobile', params)
}
// 文件上传接口
export const uploadFile = '/api/v3/student/upload2AliOss'
// 解锁
export const unlock = params => {
  return postRequest('/user/unlock', params)
}
// 个人中心发送修改邮箱验证邮件
export const sendCodeEmail = (email, params) => {
  return getRequest(`/email/sendCode/${email}`, params)
}
// 获取首页公开课信息
export const getOpenCourse = params => {
  return getRequest(`/v3/student/course/getOpenCoursesList`, params)
}
// 获取首页苹果树信息
export const getAppleTree = params => {
  return getRequest('/v3/student/getGrowingTreeList', params)
}
// 获取首页创作活动
export const getActivitiesList = params => {
  return getRequest('/v3/student/activities/getActivitiesList', params)
}
// 获取首页我的课程
export const getMyCourseList = params => {
  return getRequest('/v3/student/getMyTeachingPlanList', params)
}
// 获取教学计划详情
export const getMyTeachingPlanDetail = params => {
  return getRequest('/v3/student/getMyTeachingPlanDetail', params)
}
// 解密视频
export const getPlayURL = params => {
  return getRequest('/v1/user/getPlayURL/' + params, {})
}
// 获取首页同学动态
export const getClassmateDynamicList = params => {
  return getRequest('/v3/student/getClassmateDynamicList', params)
}
// 获取首页我的动态
export const getMyDynamic = params => {
  return getRequest('/v3/student/myDynamic', params)
}
// 获取首页排行榜
export const getOpusCountTop = params => {
  return getRequest('/v3/student/getWeeklyOpusCountTop', params)
}
// 获取首页我的成就
export const getMyAchievements = params => {
  return getRequest('/v3/student/getMyAchievements', params)
}
// 作品广场最火作品
export const getTheMostPopularOpusList = params => {
  return getRequest(`/v3/student/getTheMostPopularOpusList?limitCount=4`, params, true)
}
// 作品广场每月精品
export const getRecommendOpusList = params => {
  return getRequest('/v3/student/getRecommendOpusList?limitCount=1000', params, true)
}
// 校内作品广场最火作品
export const getSchoolTheMostPopularOpusList = params => {
  return getRequest(`/v3/student/getSchoolTheMostPopularOpusList?limitCount=4`, params, true)
}
// 校内作品广场每月精品
export const getSchoolRecommendOpusList = params => {
  return getRequest('/v3/student/getSchoolRecommendOpusList?limitCount=1000', params, true)
}
// 作品广场最新作品标签
export const getOpusTagList = params => {
  return getRequest('/v3/student/getOpusTagList', params, true)
}
// 作品广场最新作品数据
export const getLatestOpusList = params => {
  return getRequest('/v3/student/getLatestOpusList', params, true)
}
// 获取我的作品模板类型
export const getThemeTemplateTypeList = params => {
  return getRequest('/v3/student/getThemeTemplateTypeList', params,true)
}
// 获取我的作品
export const getMyOpusList = params => {
  return getRequest('/v3/student/getMyOpusList', params)
}
// 解锁模板
export const toUnlock = params => {
  return getRequest('/v3/student/common/themeTemplate/unlock', params)
}
// 校内广场
export const operationSchoolOpusOpen = params => {
  return getRequest('/v3/student/operationSchoolOpusOpen', params)
}
// 公开作品
export const operationOpusOpen = params => {
  return getRequest('/v3/student/operationOpusOpen', params)
}
// 关闭作品
export const operationOpusClose = params => {
  return getRequest('/v3/student/operationOpusClose', params)
}
// 查看
export const toView = params => {
  return getRequest('/v3/student/common/operationOpusView', params)
}
// 点赞
export const toPraise = params => {
  return getRequest('/v3/student/common/operationOpusPraise/' + params)
}
// 收藏
export const toCollection = params => {
  return getRequest('/v3/student/common/operationOpusCollection/' + params)
}
// 获取同班同学卡片
export const getMyClassmateCard = params => {
  return getRequest('/v3/student/getMyClassmateCard', params)
}
// 获取我的同学列表
export const getMyClassmateList = params => {
  return getRequest(`/v3/student/getMyClassmateList`, params)
}
// 获取同学作品时间轴
export const getStudentOpusTimeline = params => {
  return getRequest('/v3/student/getStudentOpusTimeline', params)
}
// 获取学生信息
export const getStudentInfo = params => {
  return getRequest('/v3/student/getStudentInfo', params)
}
// 获取我的作品模板列表
export const getThemeTemplateList = params => {
  return getRequest('/v3/student/getThemeTemplateList', params, true)
}
// 获取我的精品收藏
export const getGoodsCollectionList = params => {
  return getRequest('/v3/student/getMyCollectionList/' + params)
}

// 获取参考资料收藏
export const getMyCollecCourseResourcesList = params => {
  return getRequest('/v3/student/getMyCollectionCourseResourcesList', params)
}
// 获取用户中心我的积分
export const getMyIntegralList = params => {
  return getRequest('/v3/student/getMyIntegralList', params)
}
// 获取用户中心我的勋章
export const getMyMedalList = params => {
  return getRequest('/v3/student/getMyMedalList', params)
}
// 获取我的学习我的课程
export const getStudentsCourseList = params => {
  return getRequest('/v3/student/getMyCourseList', params)
}
// 获取我的学习参考资料
export const getCourseReferenceList = params => {
  return getRequest('/v3/student/getCourseReferenceList', params, true)
}
// 获取我的学习参考资料详情
export const getCourseReferenceDetails = params => {
  return getRequest('/v3/student/courseReferenceDetails/' + params, {}, true)
}
// 获取我的学习参考资料详情评论
export const getCourseReferenceCommentsList = params => {
  return getRequest('/v3/student/getCourseReferenceCommentsList', params, true)
}
// 获取课程列表
export const findPageList = params => {
  return getRequest('/v3/student/course/getStudentUserCoursesDetailList', params)
}
// 获取课节详情 getStudentUserCoursesDetail
export const getCoursesDetail = params => {
  return getRequest('/v3/student/course/getStudentUserCoursesDetail', params)
}

// 获取登录后作品详情
export const getOpusDetails = params => {
  return getRequest('/v3/student/getOpusDetails', params, true)
}
// 获取活动详情
export const getActivityDetails = params => {
  return getRequest(`/v3/student/activities/getActivityDetails/${params}`)
}

// 下载sb3文件
export const getOssDownloadUrl = params => {
  return getRequest('/v3/student/getOpusPathFormAliOss', params, true)
}

// 获取sb3文件详细信息
export const getInfo = params => {
  return getRequest('/v2/opus/findByOpusPath', params)
}
// 初始化验证码
export const initCaptcha = params => {
  return getRequest('/common/captcha/init', params)
}
// 注册
export const regist = params => {
  return postRequest('/v3/student/register', params, true)
}
// 验证码渲染图片接口
export const drawCodeImage = '/xboot/common/captcha/draw/'

// 获取课程云文件
export const getCloudFile = params => {
  return getRequest(`/v3/student/cloudFile/getCloudFile`,params)
}
//上传文件
export const uploadCloudFile = (params) => {
  return uploadRequest(`/v3/student/cloudFile/uploadCloudFile`,params)
}
// 获取课程云文件
export const deleteCloudFile = params => {
  return getRequest(`/v3/student/cloudFile/deleteCloudFile`,params)
}
// 获取课程云文件
export const getCloudFileTree = params => {
  return getRequest(`/v3/student/cloudFile/getCloudFileTree`,params)
}
// 获取课程附件文件
export const getResourceFile = params => {
  return getRequest(`/v3/student/resourceFile/getResourceFile`,params)
}

//上传文件
export const uploadFileByFileName = (params) => {
  return uploadRequest(`/v3/student/cloudFile/uploadFileByFileName`,params)
}

// showScratch
export const showScratchEventTracking = params => {
  return postRequest('/v3/student/common/showScratchEvent/tracking', params)
}




// WEBPACK FOOTER //
// ./src/api/index.js